export const CHAT_ROLES = {
  user: 'user',
  assistant: 'assistant'
}